import { ACTION } from './constants';
import request from '../../../../utils/request';
import { requestConfig } from '../../../../config/apiResource';
import {showMainLoader, hideMainLoader} from '../../../actions';
import {formDataGenerator} from "../../../../utils/common";

export function getIAPWomenData(formData) {
    return dispatch => {
        return request(requestConfig.getIAPWomenData(formData))
            .then((json) => {
                json && dispatch({ type: ACTION.GET_IAP_WOMEN_CONTENT, data: json.data });
                return json;
            }).catch((error) => {
                console.log("Got Error with IAP Women data: " + error)
            });
    }
 }
 
 export function WebinarRegistration(formData) {
    return dispatch => {
        // dispatch(showMainLoader());
        return request(requestConfig.WebinarRegistration(formData))
            .then((json) => {
                // dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.WEBINAR_REGISTRATION , data: json.data });
                return json;
            }).catch((error) => {
                // dispatch(hideMainLoader());
                console.log("Got Error with Webinar Registration API: " + error)
            });
    }
 }
 
export function getsipSaheliPopup(formData) {
   return dispatch => {
       // dispatch(showMainLoader());
       return request(requestConfig.getsipSaheliPopup(formData))
           .then((json) => {
               // dispatch(hideMainLoader());
               json && dispatch({ type: ACTION.GET_SIP_SAHELI_POPUP , data: json.data });
               return json;
           }).catch((error) => {
               // dispatch(hideMainLoader());
               console.log("Got Error with sip saheli popup Registration API: " + error)
           });
   }
}

export function getIAPWomenMCQ(formData) {
    return dispatch => {
        return request(requestConfig.getIAPWomenMCQ(formData))
            .then((json) => {
                json && dispatch({ type: ACTION.GET_IAP_WOMEN_MCQ, data: json.data });
                return json;
            }).catch((error) => {
                console.log("Got Error with IAP Women MCQ: " + error)
            });
    }
}

export function SubmitMCQ(formData) {
    return dispatch => {
        // dispatch(showMainLoader());
        return request(requestConfig.SubmitMCQ(formData))
            .then((json) => {
                // dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.SUBMI_MCQ , data: json.data });
                return json;
            }).catch((error) => {
                // dispatch(hideMainLoader());
                console.log("Got Error with Submit MCQ API: " + error)
            });
    }
}
export function quizSaheliMeta(type) {
    let typeData;
    if(!__CLIENT__){
        typeData = 'sip-saheli-quiz';
    }else{
        typeData = type;
    }

    return dispatch => {
        return request(requestConfig.allSectionsMeta(typeData))
            .then((json) => {
                json && dispatch({ type: ACTION.SIP_SAHELI_META, data: json });
                return json;
            }).catch((error) => {
                console.log("Got Error with verify pan folio data: " + error)
            });
    }
}
export function SubmitEventMCQ(formData) {
    return dispatch => {
        // dispatch(showMainLoader());
        return request(requestConfig.SubmitEventMCQ(formData))
            .then((json) => {
                // dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.SUBMI_EVENT_MCQ , data: json.data });
                return json;
            }).catch((error) => {
                // dispatch(hideMainLoader());
                console.log("Got Error with Submit MCQ API: " + error)
            });
    }
}
export function getIAPRegistrationData(serverData,formData) {
    let formDataValue;
    if(serverData.url){
        formDataValue = formDataGenerator({langcode: 'en' });
    }else{
        formDataValue = formData;
    }
    return dispatch => {
        return request(requestConfig.getIAPRegistrationData(formDataValue))
            .then((json) => {
                json && dispatch({ type: ACTION.GET_IAP_REGISTRATION_DATA, data: json.data });
                return json;
            }).catch((error) => {
                console.log("Got Error with IAP Women data: " + error)
            });
    }
}
 export function RegisterRegistration(formData) {
    return dispatch => {
        // dispatch(showMainLoader());
        return request(requestConfig.RegisterRegistration(formData))
            .then((json) => {
                // dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.REGISTER_REGISTRATION , data: json.data });
                return json;
            }).catch((error) => {
                // dispatch(hideMainLoader());
                console.log("Got Error with Webinar Registration API: " + error)
            });
    }
 }
 export function RegisterSubmitMCQ(formData) {
    return dispatch => {
        // dispatch(showMainLoader());
        return request(requestConfig.RegisterSubmitMCQ(formData))
            .then((json) => {
                // dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.REGISTER_SUBMI_MCQ , data: json.data });
                return json;
            }).catch((error) => {
                // dispatch(hideMainLoader());
                console.log("Got Error with Submit MCQ API: " + error)
            });
    }
}
export function getRegistrationMedia() {
    return dispatch => {
      return request(requestConfig.getRegistrationMedia())
        .then((json) => {
            json && dispatch({ type: ACTION.REGISTER_MEDIA, data: json.data });
            return json;
        }).catch((error) => {
            console.log("Got Error with SIP Register data: " + error)
        });
    }
}